import { createMuiTheme } from '@material-ui/core/styles';
import { lightBlue, deepOrange } from '@material-ui/core/colors';

export const darkTheme = createMuiTheme({
  palette: {
    type: 'dark',
    primary: lightBlue,
    secondary: deepOrange
  }
});

export default createMuiTheme({
  palette: {
    primary: lightBlue,
    secondary: deepOrange
  }
});



// WEBPACK FOOTER //
// ./src/config/theme.js